/**
 * Normalizes a template name by:
 * - Removing % and ; characters
 * - Truncating to 50 characters
 * - Returning undefined for empty/null/whitespace-only strings
 *
 * @param name - The template name to normalize, can be undefined
 * @returns The normalized template name or undefined if empty/invalid
 */
export function normalizeTemplateName(name: string | undefined): string | undefined {
    if (!name) {
        return undefined;
    }

    let normalized = name.replace(/[%;]/g, '');

    if (!normalized) {
        return undefined;
    }

    if (normalized.length > 50) {
        normalized = normalized.substring(0, 50);
    }

    return normalized;
}
